import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=632eafc8&scoped=true"
import script from "./portal.vue?vue&type=script&lang=js"
export * from "./portal.vue?vue&type=script&lang=js"
import style0 from "./portal.vue?vue&type=style&index=0&id=632eafc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632eafc8",
  null
  
)

export default component.exports